import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.book.all(), data);
  },
  allParts(id) {
    return BackendAPI('get', ApiRoutes.book.allParts(id));
  },
  allChapters(id, pid) {
    return BackendAPI('get', ApiRoutes.book.allChapters(id, pid));
  },
  allBigQuestions(id, pid, cid) {
    return BackendAPI('get', ApiRoutes.book.allBigQuestions(id, pid, cid));
  },
};
